// @flow

import { CompanyType } from 'shared/utils/constants';
import { API_ENDPOINT } from 'shared/config';
import { fetchJsonWithTimeoutAndAbort } from 'shared/requests/fetchWithTimeout';

const SEARCH_TIMEOUT_MS = 60000;

export const searchCompanies = (
  search: string,
  type: $Values<typeof CompanyType>
) => {
  const companySearchURL = new URL(`${API_ENDPOINT}/company_search`);
  companySearchURL.searchParams.set('search_string', search);
  companySearchURL.searchParams.set('type', type);

  return fetchJsonWithTimeoutAndAbort(
    companySearchURL.toString(),
    {
      credentials: 'include'
    },
    SEARCH_TIMEOUT_MS
  );
};
